import React from "react";

import DetailedSwitchInspection from "components/Reports/Timps/Switch/switchReport.jsx";
import SwitchInspection from "components/Reports/Timps/Switch/monthlySwitchInspection";
import TNW_SwitchInspectionReport from "../../Reports/TNW/SwitchInspectionReport";
import Maintenance from "components/Reports/sims/batteryMaintenance";
import GI305Report from "components/Reports/sims/maintenance-305aView";
import GI303Report from "components/Reports/sims/maintenance-303View";
import BatteryTestReportsB12B24 from "components/Reports/sims/batteryTestReportsB12&B24";
import DefaultReport from "components/Reports/sims/defaultReport";
import SuviMargin from "components/Reports/sims/sudNicman/index";
import RelayTest from "components/Reports/sims/relayTest";
import InsulationResistance from "components/Reports/sims/insulationResistance";
import HighWayCrossing from "../../Reports/sims/highWayCrossingCombined/highWayCrossing";
import BridgeInspectionReport from "components/Reports/Timps/Bridge/monthlyBridgeInspectionView";
import CurveReport from "components/Reports/Timps/CurveReport/CurveReport";
import GI303BatteryMaintenance from "../../Reports/sims/batteryMaintenance";
import TurnoutInspectionReportView from "../../Reports/Timps/EtrSwitchReport/detailedTurnoutInspectionReportView";
import DefectReportView from "../../Reports/Timps/LineInspection/DefectReportView";
import SFRTA_SignalIncidentResponseRecord from "../../Reports/SFRTA/SignalIncidentResponseRecord";
import SFRTA_BridgeTestsAndInspectionReport from "../../Reports/SFRTA/BridgeTestsAndInspectionReport";
import SFRTA_DefectDetectorTestsAndInspectionsReport from "../../Reports/SFRTA/DefectDetectorTestsAndInspectionsReport";
import SFRTA_LockingTestsAndInspectionsReport from "../../Reports/SFRTA/LockingTestsAndInspectionsReport";
import ONR_SwitchTieRequirements from "../../Reports/ONR/SwitchTieRequirements";
import ONR_DerailInspectionAnnual from "../../Reports/ONR/DerailInspectionAnnual";
import BRC_InertRetardersInspectionReportContainer from "../../Reports/BRC/InertRetardersInspectionReport";
import SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionForm from "../../Reports/SEPTA/TrackSectionTurnoutAndSpecialWorkInspectionForm";
import ONR_DetailedAnnualInspectionOfPrivatePublicAssetsReport from "../../Reports/ONR/DetailedAnnualInspectionOfPrivatePublicAssetsReport";
import SFRTA_SwitchTestsAndInspectionsReport from "../../Reports/SFRTA/SwitchTestsAndInspectionsReport";
import ETR_DetailedCrossingReport from "../../Reports/ETR/DetailedCrossingReport";
import ETR_MonthlyCulvertReport from "../../Reports/ETR/MonthlyCulvertReport";
import InspectionOfCurves from "../../Reports/Timps/CurveReport/inspectionOfCurves";
import InspectionOfETRCurves from "../../Reports/Timps/CurveReport/inspectionOfETRCurves";

export function reportsPreview(name) {
  return reportName[name];
}

function addReportPreviewsToMultipleCodes(codes, preview) {
  return codes.reduce((result, code) => {
    result[code] = preview;
    return result;
  }, {});
}

const reportName = {
  frmMonthlySI4QNS: <SwitchInspection />,
  frmAnnualSI4QNS: <SwitchInspection />,
  frmSwitchInspection: <DetailedSwitchInspection />,

  formFicheB24: <GI305Report assetsData={[]} />,
  formFicheB12: <GI305Report assetsData={[]} />,
  formGI303: <Maintenance assetsData={[]} />,
  formFicheB12B24: <BatteryTestReportsB12B24 assetsData={[]} />,
  gi334f: <DefaultReport />,
  scp901f: <DefaultReport />,
  scp902f: <DefaultReport />,
  scp907f: <DefaultReport />,
  suivimargingi335: <SuviMargin />,
  gi329fa: <DefaultReport />,
  gi329fb: <DefaultReport />,
  gi329fc: <DefaultReport />,
  gi329fd: <DefaultReport />,
  gi329f: <DefaultReport />,
  gi313f: <DefaultReport />,
  "form234.249B_M": <HighWayCrossing />,
  "form234.251B12_M": <HighWayCrossing />,
  "form234.251B_M": <HighWayCrossing />,
  "form234.253C_M": <HighWayCrossing />,
  "form234.257A_M": <HighWayCrossing />,
  "form234.257B_M": <HighWayCrossing />,
  "form234.253A_Y": <HighWayCrossing />,
  "form234.253B_Y": <HighWayCrossing />,
  "form234.259_Y": <HighWayCrossing />,
  "form234.249B12_M": <HighWayCrossing />,
  "form234.249B_M": <HighWayCrossing />,
  relayTestForm: <RelayTest />,
  CN_MultiYear_HoldClearElectrical: <RelayTest />,
  insulationResistance: <InsulationResistance />,
  "form234.271_Q": <HighWayCrossing />,
  etrBridgeForm: <BridgeInspectionReport />,
  curveTestForm: <InspectionOfCurves basicData={{}} />,
  curveTestFormETR: <InspectionOfETRCurves basicData={{}} />,
  etrRHSwitchForm: <TurnoutInspectionReportView assetData={{ assetType: "Switch RH" }} />,
  etrLHSwitchForm: <TurnoutInspectionReportView />,
  inspectionForm1: <DefectReportView basicData={{}} issuesData={[]} />,
  inspectionForm2: <DefectReportView basicData={{}} issuesData={[]} />,
  inspectionForm3: <DefectReportView basicData={{}} issuesData={[]} />,

  sfrtaSignalIncidentResponse: <SFRTA_SignalIncidentResponseRecord isPreview={true} />,
  sfrtaBridgeLockingForm: <SFRTA_BridgeTestsAndInspectionReport isPreview={true} />,
  ...addReportPreviewsToMultipleCodes(
    ["sfrtaDraggingEquip30Days", "sfrtaHotBox30Days", "sfrtaHotBox90Days"],
    <SFRTA_DefectDetectorTestsAndInspectionsReport isPreview={true} />,
  ),
  ...addReportPreviewsToMultipleCodes(["sfrtaLockingTests"], <SFRTA_LockingTestsAndInspectionsReport isPreview={true} />),
  ...addReportPreviewsToMultipleCodes(
    [
      "sfrtaSwitchcircuitControllerNormal",
      "sfrtaSwitchcircuitControllerReverse",
      "sfrtaSwitchshuntFouling",
      "sfrtaSwitchLockRodNormal",
      "sfrtaSwitchLockRodReverse",
    ],
    <SFRTA_SwitchTestsAndInspectionsReport isPreview={true} />,
  ),
  ...addReportPreviewsToMultipleCodes(
    [
      "CN_Monthly_SwitchObstructionNormal_FRA236_382",
      "CN_Monthly_SwitchObstructionReverse_FRA236_382",
      "CN_Quarterly_SwitchCircuitControllerNormal_FRA236_103",
      "CN_Quarterly_SwitchCircuitControllerReverse_FRA236_103",
      "CN_Quarterly_FoulingCircuits_FRA236_104",
    ],
    <SFRTA_SwitchTestsAndInspectionsReport isPreview={true} />,
  ),
  ...addReportPreviewsToMultipleCodes(
    ["path_valueLocksNonCutOffQuaterly", "path_restoreFeatureOnPowerSwitches", "path_valvesAndValveMagnets"],
    <SFRTA_SwitchTestsAndInspectionsReport isPreview={true} />,
  ),

  // TIMPS Report Previews
  onrSwitchTieRequirementsForm: <ONR_SwitchTieRequirements isPreview={true} />,
  onrDerailInspectionForm: <ONR_DerailInspectionAnnual isPreview={true} />,
  onrDetAnnInspectionPriPubAssetForm: <ONR_DetailedAnnualInspectionOfPrivatePublicAssetsReport isPreview={true} />,
  brcInertRetarderForm: <BRC_InertRetardersInspectionReportContainer isPreview={true} />,
  septaSubOpDivTurnoutInspectionForm: <SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionForm isPreview={true} />,
  etrMonthlyCulvertForm: <ETR_MonthlyCulvertReport isPreview={true} />,
  etrDetailedCrossingForm: <ETR_DetailedCrossingReport isPreview={true} />,
};



// WEBPACK FOOTER //
// ./src/components/SetupPage/GITestAssetTypes/reportsPreview.jsx